import { GoogleApiWrapper, Map } from "google-maps-react";
import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import mapStyle from "./mapStyle.json";
import Bounce from "react-reveal/Bounce";


class GoogleMap extends Component {
	state = {
		initialPosition: {
			lat: 19.0760,
			lng: 72.8777,
		},		
		oc_lattitude:19.0760,
		oc_longitude:72.8777,
		zoom: 15,
		is_open_map:0
	};

	componentDidMount() {
		if (localStorage.getItem("oc_lattitude")!='') {
			const lat=localStorage.getItem('oc_lattitude');
			const lng=localStorage.getItem('oc_longitude');
			this.setState({ initialPosition: { lat: lat, lng:lng},oc_lattitude:lat,oc_longitude:lng });
		}
		setTimeout(() => {
			this.setState({ zoom: 18 });
		}, 1 * 1000);
	}

	componentDidUpdate(nextProps){
		if (this.state.oc_lattitude !== nextProps.oc_lattitude) {
			this.setState({ is_open_map: nextProps.is_open_map});
			this.setState({ initialPosition: { lat: nextProps.oc_lattitude, lng: nextProps.oc_longitude},oc_lattitude:nextProps.oc_lattitude,oc_longitude:nextProps.oc_longitude });
		}
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.is_open_map) {
			this.setState({ is_open_map: nextProps.is_open_map});
			this.setState({ initialPosition: { lat: nextProps.oc_lattitude, lng: nextProps.oc_longitude},oc_lattitude:nextProps.oc_lattitude,oc_longitude:nextProps.oc_longitude });
		} 
		if (nextProps.oc_lattitude) {
			setTimeout(() => {
			this.setState({ initialPosition: { lat: nextProps.oc_lattitude, lng: nextProps.oc_longitude},oc_lattitude:nextProps.oc_lattitude,oc_longitude:nextProps.oc_longitude })
			},500);
			
		} 
	}

	render() {
		return (
			<React.Fragment>
				{(() => {
					if (this.state.is_open_map>0) {
						return (
							<>
				<div class="map_popup">
				<Map
					google={this.props.google}
					style={{
						width: "100%",
						height: window.innerHeight - 200,
					}}
					initialCenter={{
						lat: this.state.oc_lattitude,
						lng: this.state.oc_longitude,
					}}
					onDragend={(t, map, coord) => this.props.onMarkerDragEnd(map)}
					zoom={this.state.zoom}
					styles={mapStyle}
					zoomControl={false}
					mapTypeControl={false}
					scaleControl={true}
					streetViewControl={false}
					fullscreenControl={false}
					onReady={(mapProps, map) => {
						this.props.reverseLookup(this.state.initialPosition.lat, this.state.initialPosition.lng);
						localStorage.setItem("userLat", map.center.lat());
						localStorage.setItem("userLng", map.center.lng());
					}}
					onDragstart={() => {
						this.props.handleDragging(true);
					}}
				>
					{/* <Marker position={this.state.initialPosition}></Marker> */}
				</Map>

				<div className="center-marker-pulse">
					<Bounce top duration={1000}>
						<img src="/assets/img/dragable-markerv2.png" alt="Marker" className="center-marker" />
					</Bounce>
				</div>
				</div>
							</>
						)
					}
				})()}
				
				
				
			</React.Fragment>
		);
	}
}

const MapLoadingContainer = () => (
	<ContentLoader height={400} width={window.innerWidth} speed={1.2} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
		<rect x="0" y="0" rx="0" ry="0" width={window.innerWidth} height="400" />
	</ContentLoader>
);

export default GoogleApiWrapper({
	apiKey: 'AIzaSyCqURvpBOM-f6MHU5TkeJ2wLsagZZCL7ns',
	LoadingContainer: MapLoadingContainer,
})(GoogleMap);
